<section class="topbar">
    <div class="container container-xs">
        <div class="row">
            <div class="col-md-12">
                <nav class="navbar navbar-expand-lg  navigation">
                    <a class="navbar-brand" href="#">
                        <img src="https://www.webcampus.uade.edu.ar/Images/logo_fundacion_uade_azulsobreclaros_sin.svg" alt="Ayuda UADE" width="100px" height="90px">
                        <h1 class="institucional">Centro de ayuda</h1>
                    </a>
                    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav ml-auto main-nav ">
                            <!--
                            <li class="nav-item ">
                                <a class="nav-link" href="index.html"><i class="fas fa-question"></i> Preguntas Frecuentes</a>
                            </li>

                            <li class="nav-item">
                                <a class="nav-link" href="dashboard.html"><i class="fas fa-video"></i> Video tutoriales</a>
                            </li>

                            <li class="nav-item dropdown dropdown-slide">
                                <a class="nav-link dropdown-toggle" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-cloud-download-alt"></i> Descargas <span><i class="fa fa-angle-down"></i></span>
                            </a>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" href="category.html">Auto Instalador Wifi</a>
                                    <a class="dropdown-item" href="single.html">Programas Microsoft</a>
                                </div>
                            </li>
                        -->
                        </ul>
                        <ul class="navbar-nav my-lg-0">
                            <li class="nav-item" *ngIf="!usuarioService.usuario" >
                                <a class="nav-link login" (click)="login()"> Ingresar</a>
                            </li>
                            <!-- ============================================================== -->
                            <!-- Profile -->
                            <!-- ============================================================== -->
                            <li class="nav-item dropdown usu" *ngIf="usuarioService.usuario">

                                <a class="nav-link dropdown-toggle waves-effect waves-dark" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <img [src]="usuarioService.usuario.imagen" alt="user" class="careto" />
                                </a>

                                <div class="dropdown-menu dropdown-menu-right animated fadeIn fast" style="min-width: max-content !important;">
                                    <ul class="dropdown-user">
                                        <li>
                                            <div class="dw-user-box">
                                                <div class="u-text">
                                                    <h4>{{ usuarioService.usuario.displayName }}</h4>
                                                    <p class="text-muted"> {{ usuarioService.usuario.mail }} </p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="secondary"><a (click)="logout()"><i class="fa fa-power-off"></i> Cerrar sesión</a></li>
                                    </ul>
                                </div>
                            </li>
                        </ul>

                    </div>
                </nav>
            </div>
        </div>
    </div>
</section>
